export const EMPTY_PHARMACY_FORM = {
    name: "",
    address: "",
    phone: "",
    template: "",
    email: "",
    mailHost: "",
    mailPassword: "",
    partenaires: [],
};

export const EMPTY_USER_FORM = { email: "", password: "", role: "PHARMACIEN" };

export const PASSWORD_RULES = [
    { label: "8 caractères minimum", test: p => p.length >= 8 },
    { label: "Une majuscule", test: p => /[A-Z]/.test(p) },
    { label: "Un chiffre", test: p => /\d/.test(p) },
    { label: "Un caractère spécial (!@#$%...)", test: p => /[!@#$%^&*()_+\-=[{};':"\\|,.<>/?]/.test(p) },
];

const ROLE_LABELS = {
    TITULAIRE: "Titulaire",
    PHARMACIEN: "Pharmacien",
    ADMIN: "Admin",
    SUPER_ADMIN: "Super Admin",
    PRODUCTEUR: "Producteur",
    LIVREUR: "Livreur",
};

export const USER_ROLE_OPTIONS = ["TITULAIRE", "ADMIN", "PHARMACIEN", "PRODUCTEUR", "LIVREUR"];

export const COMMANDE_BADGE_METRIC_OPTIONS = [
    { value: "NON_FAVORITES", label: "Commandes non favorites" },
    { value: "UNREAD_MAILS", label: "Mails non lus non validés" },
];

const AVATAR_COLORS = ["#7c6fcd", "#3b82f6", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#06b6d4", "#f97316"];

export function roleLabel(role) {
    return ROLE_LABELS[role] ?? role;
}

export function isOrangeMailHost(host) {
    return host.trim().toLowerCase().endsWith("orange.fr");
}

export function avatarColor(name) {
    if (!name) return AVATAR_COLORS[0];
    let h = 0;
    for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) & 0xffff;
    return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

export function avatarInitials(name) {
    if (!name) return "?";
    const words = name.trim().split(/\s+/);
    return words.length === 1 ? name.slice(0, 2).toUpperCase() : (words[0][0] + words[1][0]).toUpperCase();
}

export function pharmacyToEditForm(pharmacy) {
    return {
        name: pharmacy.name ?? "",
        address: pharmacy.address ?? "",
        phone: pharmacy.phone ?? "",
        template: pharmacy.template ?? "",
        email: pharmacy.email ?? "",
        mailHost: pharmacy.mailHost ?? "",
        mailPassword: "",
        commandeBadgeMetric: pharmacy.commandeBadgeMetric ?? "NON_FAVORITES",
        commandeTourneeShortcutEnabled: pharmacy.commandeTourneeShortcutEnabled ?? false,
        partenaires: pharmacy.partenaires ?? [],
    };
}

export function pharmacyEditPayload(form) {
    const payload = { ...form };
    if (!payload.mailPassword) delete payload.mailPassword;
    return payload;
}

export function withAddedPartenaire(partenaires, value) {
    const val = value.trim();
    if (!val || partenaires.includes(val)) return null;
    return [...partenaires, val];
}

export function withoutPartenaireAt(partenaires, index) {
    return partenaires.filter((_, i) => i !== index);
}

export function apiErrorMessage(err, fallback) {
    const d = err.response?.data;
    return d?.errors?.[0]?.defaultMessage ?? d?.message ?? d?.detail ?? fallback;
}

export function userEditPayload(form) {
    const payload = { email: form.email, role: form.role };
    if (form.password) payload.password = form.password;
    return payload;
}
